<template>
  <component
    :is="types[widget.type]"
    v-bind="widgetProps"
  />
</template>

<script>
import TextWidget from '@/containers/Details/TextWidget'
import PhotoWidget from '@/containers/Details/PhotoWidget'

export default {
  props: {
    widget: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      types: {
        text: TextWidget,
        photo: PhotoWidget
      }
    }
  },
  computed: {
    widgetProps () {
      switch (this.widget.type) {
        case 'text':
          return { description: this.widget.description, title: this.widget.title }
        case 'photo':
          return {
            photos: this.widget.photos,
            description: this.widget.description,
            title: this.widget.title,
            photoDesc: this.widget.photoDesc,
            halfPhoto: this.widget.halfPhoto
          }
        default:
          console.warn('Invalid widget type')
          return {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Details/WidgetContainer.vue